import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import type { ReactNode, RefObject } from "react";
import type {
  CoworldSwitcherState,
  CoworldSwitcherLinkProps,
} from "./coworld-switcher-types";
import { CoworldSwitcherStatus } from "./coworld-switcher-status";
import { CoworldSwitcherRow } from "./coworld-switcher-row";
import { stepSwitcherRows } from "./step-switcher-rows";
import { styles } from "./coworld-switcher-rows.styles";

export function CoworldSwitcherList({
  listRef,
  state,
  query,
  onRetry,
  renderLink,
  onOpenChange,
  browseHref,
}: {
  readonly listRef: RefObject<HTMLDivElement | null>;
  readonly state: CoworldSwitcherState;
  readonly query: string;
  readonly onRetry: () => void;
  readonly renderLink: (props: CoworldSwitcherLinkProps) => ReactNode;
  readonly onOpenChange: (open: boolean) => void;
  readonly browseHref: string;
}) {
  return (
    <div ref={listRef} data-switcher-list>
      <CoworldSwitcherStatus state={state} onRetry={onRetry} />
      {state.status === "ready" &&
      query.trim() !== "" &&
      state.rows.length === 0 ? (
        <p {...stylex.props(messageStyles.message)}>
          No coworlds match &ldquo;{query.trim()}&rdquo;.
        </p>
      ) : null}
      {state.status === "ready"
        ? state.rows.map((row) => (
            <CoworldSwitcherRow
              key={row.id}
              row={row}
              renderLink={renderLink}
              onOpenChange={onOpenChange}
            />
          ))
        : null}
      {renderLink({
        href: browseHref,
        "data-switcher-row": "",
        onClick: () => onOpenChange(false),
        onKeyDown: stepSwitcherRows,
        ...stylex.props(styles.row, styles.browse),
        children: "Browse all coworlds",
      })}
    </div>
  );
}

const messageStyles = stylex.create({
  message: {
    display: "block",
    margin: 0,
    paddingInline: spacing.space12,
    paddingBlock: spacing.space8,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    color: colors.muted,
    fontStyle: "italic",
  },
});
